// @flow

const SESSION_STATUSES = {
  pending: 'pending',
  confirmed: 'confirmed',
  rescheduled: 'rescheduled',
  canceled: 'canceled',
  deleted: 'deleted',
};

export const SESSION_DISPLAY_STATUSES = {
  canceled: 'canceled',
  confirmed: 'complete',
  pending: 'upcoming',
  rescheduled: 'rescheduled',
};

export default SESSION_STATUSES;



// WEBPACK FOOTER //
// ./src/constants/session-statuses.js